export default "//cloud.imgsmail.ru/cloud.mail.ru/168288/img/build/saveSubsImage.jpg";